import React from "react";
import {Box, Button, ClickAwayListener, Popover, Stack} from "@mui/material";
import {useAuthStore} from "../../store/auth.store";

export interface PremiumMessageElementProperties {
    element?: Element
    isOpen?: boolean

    isPdf: boolean
    isFavorite: boolean
    isFavoriteInTable: boolean
    isPhone: boolean
    isMy: boolean
    isSupport: boolean
}

interface PremiumMessageElementProps {
    showPremiumMessageEl: PremiumMessageElementProperties
    setShowPremiumMessageEl: (showPremiumMessageEl:PremiumMessageElementProperties) => void
}

export function PremiumMessageElement({showPremiumMessageEl, setShowPremiumMessageEl}: PremiumMessageElementProps) {
    const {jwt, setShowLogin} = useAuthStore();

    return <Popover
        anchorEl={showPremiumMessageEl.element!}
        open={!!showPremiumMessageEl.isOpen}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
        }}
    >
        <ClickAwayListener onClickAway={() => setShowPremiumMessageEl({
            ...showPremiumMessageEl, isOpen: false, element: undefined
        })}>
            <Box sx={{ padding: '20px' }}>
                <Box className={"mb-15"}>
                    {showPremiumMessageEl.isFavorite && 'Sign up to filter proposals by favorite status.'}
                    {showPremiumMessageEl.isFavoriteInTable && 'Sign up to modify your favorites list.'}
                    {showPremiumMessageEl.isPhone && 'Sign up to view phone numbers.'}
                    {showPremiumMessageEl.isMy && 'Sign up to filter by your own proposals.'}
                    {showPremiumMessageEl.isSupport && 'Sign up to create a support ticket.'}
                    {showPremiumMessageEl.isPdf
                        && (jwt
                                ? 'Obtain premium access to generate PDF documents.'
                                : 'Sign up to generate PDF documents.'
                        )}
                </Box>
                <Stack flexDirection={"row"} alignItems={"center"} justifyContent={"space-between"}>
                    <Button onClick={() => setShowPremiumMessageEl(
                        {...showPremiumMessageEl, isOpen: false, element: undefined}
                    )}>Close</Button>
                    <Button onClick={() => {
                        setShowLogin(true);
                        setShowPremiumMessageEl({
                            ...showPremiumMessageEl, isOpen: false, element: undefined
                        });
                    }}>Register (login)</Button>
                </Stack>
            </Box>
        </ClickAwayListener>
    </Popover>
}